// this function is used to support a sale initiative for targeted pages to liquidate fringe size inventory

import { fringeSizes } from '../constants/productSizes';

// it may move to configuration at some point if this initial initiative ends up being long lived
export const isFringeSize = (size) => {
  return fringeSizes.includes(size);
};
